/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Aktuellemasernimpfungnachgewiesen2Inputs */

const de__field_aktuellemasernimpfungnachgewiesen2 = /** @type {(inputs: _Field_Aktuellemasernimpfungnachgewiesen2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`aktuelle Masernimpfung nachgewiesen`)
};

/**

* @param {_Field_Aktuellemasernimpfungnachgewiesen2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_aktuellemasernimpfungnachgewiesen2 = /** @type {((inputs?: _Field_Aktuellemasernimpfungnachgewiesen2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Aktuellemasernimpfungnachgewiesen2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_aktuellemasernimpfungnachgewiesen2(inputs)
});
export { _field_aktuellemasernimpfungnachgewiesen2 as "_field_aktuelleMasernimpfungNachgewiesen" }